import { useState, useEffect } from 'react';
import { useRpcSender } from "../RpcSender";
import { GetTeamMemberInvitesResponse, ITeamMemberInviteProto } from "../../provider_api";
import { RpcState } from "../RpcState";

export const useTeamMemberInvites = () => {
  const rpcSender = useRpcSender();
  const [invites, setInvites] = useState<ITeamMemberInviteProto[]>([]);
  const [rpcState, setRpcState] = useState<RpcState>({state: "pending"});

  useEffect(() => {
    setRpcState({state: 'pending'});
    setInvites([]);

    rpcSender.send('get_team_member_invites', new Uint8Array())
      .then(r => {
        const response = GetTeamMemberInvitesResponse.decode(r);
        if (!response.okay) {
          setRpcState({state: 'error', message: 'Error getting invites'});
          return;
        }

        setRpcState({state: 'success'})
        setInvites(response.invite);
      })
      .catch(e => {
        setRpcState({state: 'error', message: e})
      });
  }, []);

  return { invites, rpcState };
};
